import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
const stats = [{
  value: "2026",
  label: "Current Index Year"
}, {
  value: "100+",
  label: "Metrics analysed"
}, {
  value: "Near real‑time",
  label: "Data latency"
}];
export default function ElevateYourImpact() {
  return <section data-section-id="252857" id="index-overview" className="bg-background text-foreground relative overflow-hidden py-24 md:py-32">
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background to-background pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 flex flex-col items-center text-center">
        {}
        <span className="text-primary tracking-widest uppercase text-sm font-semibold mb-6 font-default">
          AIB ANALYTICS FRAMEWORK
        </span>

        {}
        <h1 className="font-default text-5xl md:text-7xl lg:text-8xl font-bold mb-8 text-foreground leading-tight max-w-5xl">
          The Value for Money Index
        </h1>

        {}
        <p className="text-muted-foreground text-lg md:text-xl max-w-2xl mb-12 font-default">
          A comprehensive, data‑driven benchmark evaluating household value perception and institutional performance through the AIB methodology.
        </p>

        {}
        <div className="flex flex-col sm:flex-row gap-4 mb-24 w-full sm:w-auto">
          <Button size="lg" className="w-full sm:w-auto font-default h-14 px-8 text-base bg-primary text-primary-foreground" asChild>
            <Link to="/ValueForMoneyIndexPage">
              View Full Index
              <ArrowRight className="ml-2 size-5" />
            </Link>
          </Button>
          <Button size="lg" variant="outline" className="w-full sm:w-auto border-foreground/20 text-foreground hover:bg-foreground/5 font-default h-14 px-8 text-base" asChild>
            <Link to="/MethodologyPage">Our Methodology</Link>
          </Button>
        </div>

        {}
        <div className="flex flex-col md:flex-row w-full max-w-5xl justify-between items-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className="flex flex-col md:flex-row items-center w-full md:w-auto flex-1">
              <div className="flex flex-col items-center justify-center py-10 md:py-4 w-full">
                <span className="text-primary font-default text-6xl md:text-7xl font-bold mb-3">
                  {stat.value}
                </span>
                <span className="text-muted-foreground text-sm uppercase tracking-wider font-default font-medium">
                  {stat.label}
                </span>
              </div>
              
              {}
              {i < stats.length - 1 && <>
                  <Separator orientation="horizontal" className="md:hidden w-full bg-border" />
                  <Separator orientation="vertical" className="hidden md:block h-24 bg-border" />
                </>}
            </div>)}
        </div>
      </div>
    </section>;
}